import { setFindingsEdited as setFindingsEditedDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    edited?: boolean;
}

export const setFindingsEdited = ({
    edited,
}: Props) => setFindingsEditedDiagram({
    edited,
});

